import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState({
    d: 5,
    h: 19,
    m: 9,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          d,
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;else {
              h = 23;
              if (d > 0) d--;
            }
          }
        }
        return {
          d,
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="bg-brand-red flex items-center justify-center gap-5 py-3 px-5 flex-wrap" data-id="element-331">
      <span className="font-display text-[13px] font-semibold tracking-[2px] text-white uppercase" data-id="element-332">
        🔥 INSCRIPCIONES CIERRAN EN
      </span>
      <div className="flex items-center gap-1.5" data-id="element-333">
        <div className="bg-black text-white font-display text-lg font-bold py-1 px-2.5 rounded min-w-[44px] text-center" data-id="element-334">
          {pad(timeLeft.d)}
        </div>
        <span className="text-lg font-bold text-white" data-id="element-335">:</span>
        <div className="bg-black text-white font-display text-lg font-bold py-1 px-2.5 rounded min-w-[44px] text-center" data-id="element-336">
          {pad(timeLeft.h)}
        </div>
        <span className="text-lg font-bold text-white" data-id="element-337">:</span>
        <div className="bg-black text-white font-display text-lg font-bold py-1 px-2.5 rounded min-w-[44px] text-center" data-id="element-338">
          {pad(timeLeft.m)}
        </div>
        <span className="text-lg font-bold text-white" data-id="element-339">:</span>
        <div className="bg-black text-white font-display text-lg font-bold py-1 px-2.5 rounded min-w-[44px] text-center" data-id="element-340">
          {pad(timeLeft.s)}
        </div>
      </div>
      <button onClick={scrollToPricing} className="bg-white text-brand-red font-display text-[13px] font-bold py-2 px-5 rounded-md tracking-[1px] uppercase whitespace-nowrap hover:bg-gray-100 transition-colors" data-id="element-341">
        VER OFERTA
      </button>
    </div>;
}